import { OrganizationKeyName } from "../../../model/Organization";
import { GetOrderListFilters } from "../model/GetOrderListFilters";
import { GetOrderListOrderBy } from "../model/GetOrderListOrderBy";

export const GET_ORDER_LIST = "SHOP:GET_ORDER_LIST";

export const getOrderListAction = (
  organization: OrganizationKeyName,
  filters: GetOrderListFilters,
  orderBy: GetOrderListOrderBy,
  page = 1
) => ({
  type: GET_ORDER_LIST as typeof GET_ORDER_LIST,
  organization,
  filters,
  orderBy,
  page,
});

export type GetOrderListAction = ReturnType<typeof getOrderListAction>;
